import { Link } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { FunctionComponent, ReactElement } from "react";

interface ClaimHyperlinkProps {
	linkText: string;
	linkHref: string;
	isExternal?: boolean;
}

const ClaimHyperlink: FunctionComponent<ClaimHyperlinkProps> = (props: ClaimHyperlinkProps): ReactElement => {
	const { linkText, linkHref, isExternal = true } = props;
	return (
		<Link
			isExternal={isExternal}
			color="orange.600"
			fontSize="16px"
			fontWeight="400"
			lineHeight="1.5"
			ml="4px"
			as={RouterLink}
			to={linkHref}>
			{linkText}
		</Link>
	);
};

export default ClaimHyperlink;
